import { provinceCodes } from "@clcdev/react-core/lib/province-codes";

export const country = "CA";
export const countryName = "Canada";
export const postalLabel = "Postal Code";
export const regionLabel = "Province";
export const regionCodes = provinceCodes;